import { ChannelView, agentInPlan, usePlan } from '@elva/ui';
import { useWorkspaceLabel } from '@elva/platform';

/** AI Brain › AI Receptionist (spec 39): the Call channel cards and the Receptionist's
 * own cards, one store with Channels › Call. On core plan, a Not-in-your-plan card (spec 37). */
export function SettingsReceptionistPage() {
  const location = useWorkspaceLabel();
  const plan = usePlan();
  if (!agentInPlan('receptionist', plan)) {
    return (
      <div className="mx-auto max-w-[760px] px-1 pt-2">
        <div className="rounded-[16px] border border-dashed border-[var(--cream-2)] bg-[var(--cream-0)] p-6">
        <div className="text-[15px] font-bold text-[var(--ink-1)]">AI Receptionist — not in your plan</div>
        <p className="mt-2 text-[13px] leading-[1.6] text-[var(--ink-2)]">
          The AI Receptionist answers every call on its own, and it’s what turns on AI calls for Reminders,
          Recall, Gap Filler and A/R, warm transfer and the live call monitor.
        </p>
        <a
          href="/ai-team#receptionist"
          className="mt-4 inline-flex items-center rounded-[var(--r-md)] border border-[var(--cream-2)] px-3 py-1.5 text-[12.5px] font-semibold text-[var(--ink-1)] hover:border-[var(--cream-shadow)]"
        >
          Talk to the ELVA team
        </a>
        </div>
      </div>
    );
  }
  return <ChannelView channel="call" location={location} />;
}
